import React from "react";
import * as S from "./ImageButtonsStyle";

const ImageButtons = (props) => {
  const combinations = props.combinations;
  const correctAnswerCombination = props.correctAnswerCombination;

  if (!correctAnswerCombination) return null;

  return (
    <S.ButtonsContainer>
      {combinations.map((res, index) => {
        return (
          <S.Container key={index}>
            <S.Image
              src={require(`./images/${res}.jpg`)}
              alt={res}
              onClick={() => props.onSaveNumberBtnClick(res)}
            />
          </S.Container>
        );
      })}
    </S.ButtonsContainer>
  );
};

export default ImageButtons;
